module.exports = __webpack_public_path__ + "static/media/diamondQuilting.3da02388.png";